export { default } from "./Badge";
export { type TBadgeVariant, type TBadgeProps } from "./types";
